import axios from 'axios';

export const postMethod = async (url, token, values) => {
    const response = await axios({
        method: 'POST',
        url,
        data: values,
        headers: {
            "Authorization": `Bearer ${token}`,
            'Content-Type': "application/json",
        }
    })
    return response;


}
